import { createRoot } from "react-dom/client";
import React, {Fragment, useState, useEffect, useRef, useCallback} from "react";
import axios from "axios";
const apiRoot = process.env.MIX_API_ROOT;
import { Modal } from "bootstrap";
import PaginationControl from "./PaginationControl";
import ErrorDisplay from "./ErrorDisplay";

const initSelectTaxa = (elementId) => {
    const selectTaxaContainer = document.getElementById(elementId);
    if (selectTaxaContainer) {
        const errorStatus = selectTaxaContainer.attributes.error.value;
        const errorMessage =
            selectTaxaContainer.attributes["error-message"].value;
        const taxa = JSON.parse(selectTaxaContainer.attributes["taxa"].value);
        const selectCollectionRoot = createRoot(selectTaxaContainer);
        selectCollectionRoot.render(
            <SelectTaxa
                selectedTaxa={taxa}
                error={errorStatus}
                errorMessage={errorMessage}
            />
        );
    }
};

const SelectTaxa = (props) => {
    const [taxa, setTaxa] = useState([]);
    const [taxaLoading, setTaxaLoading] = useState(true);
    const [selectedTaxa, setSelectedTaxa] = useState(props.selectedTaxa);
    const [showAddTaxon, setShowAddTaxon] = useState(false);

    const refreshList = () => {
        const url = apiRoot + "/taxa";
        setTaxaLoading(true);
        axios.get(url).then((response) => {
            setTaxa(response.data);
            setTaxaLoading(false);
        });
    }

    useEffect(() => {
        refreshList();
    }, []);

    useEffect(() => {
        let nameOverrideContainer = document.getElementById(
            "name-override-container"
        );
        let specimenNameOverrideContainer = document.getElementById(
            "specimen-common-name-container"
        );
        if (nameOverrideContainer !== null && specimenNameOverrideContainer !== null) {
            selectedTaxa.forEach((taxa) => {
                if (taxa.name.toLowerCase().includes("indet")) {
                    nameOverrideContainer.classList.remove("d-none");
                    specimenNameOverrideContainer.classList.remove("d-none");
                }
            });
        }
    }, [selectedTaxa]);

    let taxaButtons = selectedTaxa.map((taxon) => {
        return (
            <TaxonButton
                key={taxon.id}
                taxon={taxon}
                remove={(e) => {
                    handleRemoveTaxonClick(taxon, e);
                }}
            ></TaxonButton>
        );
    });

    let hiddenInputClass = "";
    if (props.error === "valid") {
        hiddenInputClass = "is-valid";
    } else if (props.error === "yes") {
        hiddenInputClass = "is-invalid";
    }

    let hiddenSelectedTaxaInputs = selectedTaxa.map((taxon) => {
        return (
            <input
                className={hiddenInputClass}
                name={"taxa-ids[]"}
                key={taxon.id}
                type={"hidden"}
                value={taxon.id}
            ></input>
        );
    });
    if (hiddenSelectedTaxaInputs.length === 0) {
        hiddenSelectedTaxaInputs.push(
            <input
                className={hiddenInputClass}
                name={"taxa-ids"}
                key={"none"}
                type={"hidden"}
                value=""
            ></input>
        );
    }

    const handleAddTaxonButtonClick = (e) => {
        e.preventDefault();
        setShowAddTaxon(true);
    };

    const addTaxonHandler = (newTaxon) => {
        if (!selectedTaxa.some((taxon) => taxon.id === newTaxon.id)) {
            setSelectedTaxa((selectedTaxa) => [...selectedTaxa, newTaxon]);
        }

        setShowAddTaxon(false);
    };

    const handleRemoveTaxonClick = (clickedTaxon, e) => {
        e.preventDefault();
        let newSelectedTaxaList = [];
        selectedTaxa.forEach((taxon) => {
            if (taxon !== clickedTaxon) {
                newSelectedTaxaList.push(taxon);
            }
        });
        setSelectedTaxa(newSelectedTaxaList);
    };

    return (
        <Fragment>
            <div className={"row"}>
                <div className={"form-label"}>Taxa</div>
            </div>
            <div className={"row"}>
                <div className={"col-auto"}>{taxaButtons}</div>
                <div className={"col-auto ms-auto"}>
                    {showAddTaxon ? null : (
                        <button
                            className={"btn btn-primary"}
                            type="button"
                            onClick={handleAddTaxonButtonClick}
                            disabled={taxaLoading}
                        >
                            {taxaLoading ? "Loading Taxa" : "Add Taxon"}
                        </button>
                    )}
                </div>
            </div>
            {hiddenSelectedTaxaInputs}
            {showAddTaxon ? (
                <TaxonSelection
                    taxa={taxa}
                    addTaxon={addTaxonHandler}
                    setShowAddTaxon={setShowAddTaxon}
                    refreshList={refreshList}
                    taxaLoading={taxaLoading}
                />
            ) : null}

            <ErrorDisplay {...props} />
        </Fragment>
    );
};

const TaxonButton = (props) => {
    return (
        <div className={"btn-group me-1 mb-1"}>
            <div className={"btn btn-outline-dark disabled"}>
                <strong>{getTaxonLabel(props.taxon)}</strong>
            </div>
            <button className={"btn btn-dark"} type="button" onClick={props.remove}>
                {String.fromCharCode(215)}
            </button>
        </div>
    );
};

const getTaxonLabel = (taxon) => {
    let taxonLabel = "";
    if (taxon.name) {
        taxonLabel = taxon.name;
        if (taxon.common_name) {
            taxonLabel += " (" + taxon.common_name + ")";
        }
    } else if (taxon.common_name) {
        taxonLabel = taxon.common_name;
    }
    return taxonLabel;
};

const TaxonSelection = (props) => {
    const [taxonName, setTaxonName] = useState("");
    const [page, setPage] = useState(1);
    const [focusedTaxonDefault, setFocusedTaxonDefault] = useState(-1);
    const taxonNameInput = useRef();
    const pageSize = 25;
    const modalRef = useRef(null);
    const itemListRef = useRef(null);
    let myModal = undefined;
    useEffect(() => {
        if (modalRef.current !== undefined) {
            myModal = new Modal(modalRef.current);
            modalRef.current.addEventListener("hidden.bs.modal", (event) => {
                props.setShowAddTaxon(false);
            });
            modalRef.current.addEventListener("shown.bs.modal", (event) => {
                taxonNameInput.current.focus();
            });
            myModal.show();
        }
        return () => {
            myModal.hide();
        };
    }, []);
    useEffect(() => {
        setFocusedTaxonDefault(-1);
        setPage(1);
    }, [taxonName]);

    let focusedTaxon = focusedTaxonDefault;
    const handleKeypress = (e)=>{
        if(e !== undefined && props.setShowAddTaxon){
            if(e.key === "ArrowUp" || e.key === "ArrowDown") {
                let numberOfPages = Math.trunc(possibleTaxons.length / pageSize);
                e.preventDefault();
                if(e.key === "ArrowUp" ){
                    if(focusedTaxon > 0) {
                        focusedTaxon--;
                    } else {
                        if(page > 1) {
                            setPage(page - 1);
                            setFocusedTaxonDefault(pageSize);
                            return;
                        } else {
                            taxonNameInput.current.focus();
                            focusedTaxon = -1;
                            return;
                        }
                    }
                } else if(e.key === "ArrowDown") {
                    if(focusedTaxon < itemListRef.current.children.length - 1 ) {
                        focusedTaxon++;
                    }  else if(page <= numberOfPages) {
                        setPage(page+1)
                        focusedTaxon = -1;
                        setFocusedTaxonDefault(-1);
                        taxonNameInput.current.focus();
                        return;
                    }
                }
                itemListRef.current.children[focusedTaxon].focus()
            }

        }
    };
    useEffect(() => {
        document.addEventListener("keydown",handleKeypress,false);
        return () => {
            document.removeEventListener("keydown",handleKeypress, false)
        }
    }, [handleKeypress]);
    const handleTaxonNameChange = (event) => {
        const found = props.taxa.find((taxon) => {
            return !!taxon.name
                .toLowerCase()
                .startsWith(event.target.value.toLowerCase());
        });
        if (found !== undefined) {
            setTaxonName(event.target.value);
        }
    };

    const openNewTaxon = () => {
        let openurl = '/taxa/create';
        window.open(openurl, '_blank');
    };

    let possibleTaxons = [];
    props.taxa.forEach((taxon) => {
        if (taxon.name.toLowerCase().startsWith(taxonName.toLowerCase())) {
            possibleTaxons.push(taxon);
        }
    });

    const handleTaxaSelection = (taxon, event) => {
        event.preventDefault();
        if (myModal !== undefined) {
            myModal.hide();
        }
        props.addTaxon(taxon);
        setTaxonName("");
    };
    let taxaItems = null;
    if (possibleTaxons.length > 0) {
        taxaItems = possibleTaxons.map((taxon) => (
            <button
                key={taxon.id}
                className={"list-group-item list-group-item-action"}
                type="button"
                onClick={(event) => {
                    handleTaxaSelection(taxon, event);
                }}
            >
                {getTaxonLabel(taxon)}
            </button>
        ));
    }

    taxaItems = taxaItems.slice((page - 1) * pageSize, page * pageSize);
    return (
        <div
            ref={modalRef}
            className="modal fade"
            id="addTaxonModel"
            tabIndex="-1"
            aria-labelledby="addTaxonModelLabel"
        >
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="addTaxonModelLabel">
                            Add Taxon
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    {
                        props.taxaLoading ?
                            <div className="modal-body p-5 align-content-center text-center">
                                Loading Taxa...
                            </div>
                        : (
                        <>
                            <div className="modal-body">
                                <label htmlFor={"taxon-name"} className={"form-label"}>
                                    Search Taxa
                                </label>
                                <input
                                    ref={taxonNameInput}
                                    id={"taxon-name"}
                                    className={"form-control"}
                                    value={taxonName}
                                    onChange={handleTaxonNameChange}
                                />
                                        <div className={"list-group mt-3"} ref={itemListRef}>{taxaItems}</div>
                                        <PaginationControl
                                            className={"pt-3"}
                                            total={possibleTaxons.length}
                                            pageSize={pageSize}
                                            setPage={setPage}
                                            currentPage={page}
                                        />
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={openNewTaxon}
                                >
                                    Add New
                                    </button>
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={props.refreshList}
                                >
                                    Refresh
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >
                                    Cancel
                                </button>
                            </div>
                        </>
                        )
                    }
                </div>
            </div>
        </div>
    );
};

export { SelectTaxa as default, initSelectTaxa };
